import { useEffect, useRef } from "react";

// Registry der aktuell aktiven, seiten-spezifischen F1-Kontexte.
// Damit weiss der globale Fallback (HelpSlideOver), ob eine Seite F1 bereits
// selbst behandelt — sonst oeffnet der Fallback die Workflow-Uebersicht.
export const activeF1Contexts = new Set();

/**
 * Globaler F1-Hook fuer Modul-spezifische Hilfe.
 *
 * Verwendung in einer Seite:
 *   useF1Help("hilfe_kunden");
 *
 * Wirkung:
 *   - Druecken von F1 verhindert Browser-Default-Hilfe
 *   - Setzt eine globale CustomEvent "graupner:f1-help" mit dem Kontext
 *   - HelpSlideOver (in App.js global gerendert) hoert auf das Event
 *     und oeffnet das Hilfe-Panel mit dem richtigen Kontext.
 */
// Stapel der F1-Kontexte: das zuletzt geöffnete (innerste) Fenster gewinnt, beim Schließen gilt wieder das vorige.
const stapel = [];
const aktualisiere = () => { activeF1Contexts.clear(); stapel.forEach((e) => { if (e.context) activeF1Contexts.add(e.context); }); };

export const useF1Help = (context) => {
  const eintrag = useRef(null);
  if (!eintrag.current) eintrag.current = { context };
  // Beim Öffnen oben auf den Stapel; ein Wechsel des Kontexts ändert nur den Eintrag (Reihenfolge bleibt)
  useEffect(() => {
    const e = eintrag.current;
    stapel.push(e);
    const onKey = (ev) => {
      if (ev.key !== "F1" || !e.context) return;
      if (stapel[stapel.length - 1] !== e) return;   // nur das innerste Fenster antwortet
      ev.preventDefault();
      ev.stopPropagation();
      window.dispatchEvent(new CustomEvent("graupner:f1-help", { detail: { context: e.context } }));
    };
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      const i = stapel.indexOf(e);
      if (i >= 0) stapel.splice(i, 1);
      aktualisiere();
    };
  }, []);
  useEffect(() => { eintrag.current.context = context; aktualisiere(); }, [context]);
};

/**
 * Hilfe zu einem Thema per Klick öffnen (A-014): für Stellen ohne eigene Seite
 * (Feld, Fenster) und fürs Handy, wo es keine F1-Taste gibt. Nutzt dasselbe Event.
 *
 *   <button onClick={() => hilfeOeffnen("hilfe_status_automatik")}>Hilfe</button>
 */
export const hilfeOeffnen = (context) => {
  window.dispatchEvent(new CustomEvent("graupner:f1-help", { detail: { context } }));
};
